
import React from 'react';
import '../styles/App.css';
import _ from 'lodash';
import InputSlider from './InputSlider';

class Prediction extends React.Component {
    constructor(props) {
        super(props);
        this.reverseOrder = props.reverseOrder !== undefined ? props.reverseOrder : false;
        this.titleRef = React.createRef();
        this.state = {
            useHyphenation: true
        };
    }

    insertSoftHyphens(text) {
        const hyphenationRules = {
            'Hypertension': 'Hyper\u00ADtension',
            'Osteoporosis': 'Osteo\u00ADporosis',
            'Malignancies': 'Malig\u00ADnancies',
            'Depression': 'Depres\u00ADsion'
        };
        
        return hyphenationRules[text] || text;
    }

    render() {
        var prob = this.props.prediction === undefined ? '...%' : _.round(this.props.prediction.prob * 100) + '%';

        // var formattedTitle = this.props.conditionTitle
        var formattedTitle = this.state.useHyphenation ? this.insertSoftHyphens(this.props.conditionTitle) : this.props.conditionTitle;
        return (
            <div className='prediction'>
                <div className='prediction-title' ref={this.titleRef} lang='en' 
                    style={{ 
                        hyphens: 'auto', 
                        // overflowWrap: 'break-word', 
                        // wordBreak: 'break-word', 
                        whiteSpace: 'normal', 
                        wordWrap: 'break-word', 
                        textAlign: 'center' 
                    }}>
                    {formattedTitle}
                </div>
                <div className='prediction-icon'>
                    <this.props.icon
                        prediction={this.props.prediction} 
                        conditionKey={this.props.conditionKey} 
                        reverseOrder={this.reverseOrder}
                        useFC={this.props.useFC}
                    />
                </div>
                {this.props.subText && (
                    <span style={{fontSize: '70%', color: 'rgba(255, 255, 255, 0.4)', fontWeight: '300'}}>
                        {this.props.subText}
                    </span>
                )}
                
            </div>
        );
    }
}

export default Prediction;
